import { Button } from '@bambi/component-library/src/components/Button';
import { PencilIcon } from '@heroicons/react/24/outline';

import { useAppDispatch } from 'src/app/store/hooks';
import { AssignmentRead } from 'src/common/external/bambi-api/bambiApi';
import { useUserRoles } from 'src/features/auth/useUserRoles';
import {
  setSelectedAssignment,
  setShowAssignmentManagementModal,
} from 'src/features/team/assignment-management/assignmentManagement.slice';

export const RowActions = ({ assignment }: { assignment: AssignmentRead }) => {
  const { isRestrictedSupport } = useUserRoles();
  const dispatch = useAppDispatch();

  const handleEditAssignment = () => {
    if (isRestrictedSupport) return;
    dispatch(setSelectedAssignment(assignment));
    dispatch(setShowAssignmentManagementModal(true));
  };

  return (
    <div className="flex items-center justify-center gap-2">
      <Button
        dataTestId="view-edit-assignment-action"
        variant="icon"
        ariaLabel="Edit Assignment"
        onClick={handleEditAssignment}
        className="hover:text-mint"
      >
        <PencilIcon className="h-6 w-6" />
      </Button>
    </div>
  );
};
